module.exports = __webpack_public_path__ + "img/MAMAGABY-SELE.62d49fc0.jpg";